import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../lib/authGuard';

// Grupo de portales del backoffice (§5 de la arquitectura): guard de sesión + MFA compartido.
// Cada portal hijo monta su propio cascarón; el acceso al portal lo decide `PortalShell` con los
// permisos del menú, así que quien no tenga ninguna pantalla ve el bloqueo y no un menú vacío.
export const Route = createFileRoute('/_backoffice')({
    beforeLoad: ({ context, location }) => requireSession(context.auth, location.pathname),
});
